import i0 from "./AirDrop.png";
import i1 from "./AirplaneMode.png";
import i2 from "./AirPlayAudio.png";
import i3 from "./Apps.png";
import i4 from "./AppStore.png";
import i5 from "./BatteryUsage.png";
import i6 from "./Bluetooth.png";
import i7 from "./Brightness.png";
import i8 from "./Calculator.png";
import i9 from "./Camera.png";
import i10 from "./CellularData.png";
import i11 from "./Clipboard.png";
import i12 from "./CloudApp.png";
import i13 from "./com.soulmen.ulysses.pad.png";
import i14 from "./com.tumblr.tumblr.png";
import i15 from "./contacts.png";
import i16 from "./DeskConnect.png";
import i17 from "./Dictation.png";
import i18 from "./Dictionary.png";
import i19 from "./Documents.png";
import i20 from "./DoNotDisturb.png";
import i21 from "./Downloads.png";
import i22 from "./Dropbox.png";
import i23 from "./Editorial.png";
import i24 from "./events.png";
import i25 from "./FacebookSettings.png";
import i26 from "./FaceTime.png";
import i27 from "./Fantastical.png";
import i28 from "./FastForward.png";
import i29 from "./Favorite.png";
import i30 from "./Flashlight.png";
import i31 from "./General.png";
import i32 from "./GIF.png";
import i33 from "./Giphy.png";
import i34 from "./Graph.png";
import i35 from "./HandoffAction.png";
import i36 from "./HandoffMusic.png";
import i37 from "./health data.png";
import i38 from "./Health.png";
import i39 from "./HomeData.png";
import i40 from "./iBooks.png";
import i41 from "./iCloud.png";
import i42 from "./images.png";
import i43 from "./iTunes.png";
import i44 from "./Location.png";
import i45 from "./Mail.png";
import i46 from "./Maps.png";
import i47 from "./Markup.png";
import i48 from "./Media.png";
import i49 from "./Messages.png";
import i50 from "./Microphone.png";
import i51 from "./Music.png";
import i52 from "./Network.png";
import i53 from "./Notes.png";
import i54 from "./Notification.png";
import i55 from "./PDF.png";
import i56 from "./Phone.png";
import i57 from "./PhoneNumber.png";
import i58 from "./Photos.png";
import i59 from "./Pinboard.png";
import i60 from "./PlayPause.png";
import i61 from "./Print.png";
import i62 from "./QRCode.png";
import i63 from "./Quick Look.png";
import i64 from "./QuickTime.png";
import i65 from "./Rewind.png";
import i66 from "./RichText.png";
import i67 from "./RSS.png";
import i68 from "./Safari.png";
import i69 from "./Scripting.png";
import i70 from "./Sharing.png";
import i71 from "./ShortcutsExtension.png";
import i72 from "./Smiley.png";
import i73 from "./Sounds.png";
import i74 from "./Suggested.png";
import i75 from "./Text.png";
import i77 from "./Translate.png";
import i78 from "./TVRemote.png";
import i79 from "./TVRemote_OpenApp.png";
import i80 from "./TVRemote_PlayPause.png";
import i81 from "./TVRemote_Power.png";
import i82 from "./TVRemote_Sleep.png";
import i83 from "./Twitter.png";
import i84 from "./URL.png";
import i85 from "./Variable.png";
import i86 from "./Video.png";
import i87 from "./Wallpaper.png";
import i88 from "./Weather.png";
import i89 from "./Web.png";
import i90 from "./WiFi.png";
import i91 from "./ZZZZPackedAsset-1.0_Normal.png";
import i92 from "./ZZZZPackedAsset-2.0.png";
import i93 from "./ZZZZPackedAsset-3.0_Normal@3x.png";

export type BuiltinIcon =
	| "AirDrop.png"
	| "AirplaneMode.png"
	| "AirPlayAudio.png"
	| "Apps.png"
	| "AppStore.png"
	| "BatteryUsage.png"
	| "Battery.png"
	| "Bluetooth.png"
	| "Brightness.png"
	| "Calculator.png"
	| "Camera.png"
	| "CellularData.png"
	| "Clipboard.png"
	| "CloudApp.png"
	| "com.soulmen.ulysses.pad.png"
	| "com.tumblr.tumblr.png"
	| "contacts.png"
	| "DeskConnect.png"
	| "Dictation.png"
	| "Dictionary.png"
	| "Documents.png"
	| "DoNotDisturb.png"
	| "Downloads.png"
	| "Dropbox.png"
	| "Editorial.png"
	| "events.png"
	| "Date.png"
	| "FacebookSettings.png"
	| "FaceTime.png"
	| "Fantastical.png"
	| "FastForward.png"
	| "Favorite.png"
	| "Flashlight.png"
	| "General.png"
	| "Scripting"
	| "GIF.png"
	| "Giphy.png"
	| "Giphy"
	| "Graph.png"
	| "HandoffAction.png"
	| "HandoffMusic.png"
	| "health data.png"
	| "Health.png"
	| "HomeData.png"
	| "iBooks.png"
	| "iCloud.png"
	| "images.png"
	| "Image.png"
	| "iTunes.png"
	| "Location.png"
	| "Location"
	| "Mail.png"
	| "Maps.png"
	| "Markup.png"
	| "Media.png"
	| "Messages.png"
	| "Microphone.png"
	| "Music.png"
	| "Network.png"
	| "Notes.png"
	| "Notification.png"
	| "PDF.png"
	| "Phone.png"
	| "PhoneNumber.png"
	| "Photos.png"
	| "Pinboard.png"
	| "PlayPause.png"
	| "Print.png"
	| "QRCode.png"
	| "Quick Look.png"
	| "QuickTime.png"
	| "Rewind.png"
	| "RichText.png"
	| "RSS.png"
	| "Safari.png"
	| "Scripting.png"
	| "Sharing.png"
	| "ShortcutsExtension.png"
	| "Smiley.png"
	| "Sounds.png"
	| "Sound.png"
	| "Suggested.png"
	| "Text.png"
	| "Translate.png"
	| "TVRemote.png"
	| "TVRemote_OpenApp.png"
	| "TVRemote_PlayPause.png"
	| "TVRemote_Power.png"
	| "TVRemote_Sleep.png"
	| "Twitter.png"
	| "URL.png"
	| "Variable.png"
	| "Video.png"
	| "Wallpaper.png"
	| "Weather.png"
	| "Web.png"
	| "WiFi.png"
	| "Wi-Fi.png"
	| "ZZZZPackedAsset-1.0_Normal.png"
	| "ZZZZPackedAsset-2.0.png"
	| "ZZZZPackedAsset-3.0_Normal@3x.png"
	| "NoIcon.png";

export const BuiltinIconValueMap: { [key in BuiltinIcon]: string } = {
	"AirDrop.png": i0,
	"AirplaneMode.png": i1,
	"AirPlayAudio.png": i2,
	"Apps.png": i3,
	"AppStore.png": i4,
	"BatteryUsage.png": i5,
	"Battery.png": i5,
	"Bluetooth.png": i6,
	"Brightness.png": i7,
	"Calculator.png": i8,
	"Camera.png": i9,
	"CellularData.png": i10,
	"Clipboard.png": i11,
	"CloudApp.png": i12,
	"com.soulmen.ulysses.pad.png": i13,
	"com.tumblr.tumblr.png": i14,
	"contacts.png": i15,
	"DeskConnect.png": i16,
	"Dictation.png": i17,
	"Dictionary.png": i18,
	"Documents.png": i19,
	"DoNotDisturb.png": i20,
	"Downloads.png": i21,
	"Dropbox.png": i22,
	"Editorial.png": i23,
	"events.png": i24,
	"Date.png": i24,
	"FacebookSettings.png": i25,
	"FaceTime.png": i26,
	"Fantastical.png": i27,
	"FastForward.png": i28,
	"Favorite.png": i29,
	"Flashlight.png": i30,
	"General.png": i31,
	Scripting: i31,
	"GIF.png": i32,
	"Giphy.png": i33,
	Giphy: i33,
	"Graph.png": i34,
	"HandoffAction.png": i35,
	"HandoffMusic.png": i36,
	"health data.png": i37,
	"Health.png": i38,
	"HomeData.png": i39,
	"iBooks.png": i40,
	"iCloud.png": i41,
	"images.png": i42,
	"Image.png": i42,
	"iTunes.png": i43,
	"Location.png": i44,
	Location: i44,
	"Mail.png": i45,
	"Maps.png": i46,
	"Markup.png": i47,
	"Media.png": i48,
	"Messages.png": i49,
	"Microphone.png": i50,
	"Music.png": i51,
	"Network.png": i52,
	"Notes.png": i53,
	"Notification.png": i54,
	"PDF.png": i55,
	"Phone.png": i56,
	"PhoneNumber.png": i57,
	"Photos.png": i58,
	"Pinboard.png": i59,
	"PlayPause.png": i60,
	"Print.png": i61,
	"QRCode.png": i62,
	"Quick Look.png": i63,
	"QuickTime.png": i64,
	"Rewind.png": i65,
	"RichText.png": i66,
	"RSS.png": i67,
	"Safari.png": i68,
	"Scripting.png": i31,
	"Sharing.png": i70,
	"ShortcutsExtension.png": i71,
	"Smiley.png": i72,
	"Sounds.png": i73,
	"Sound.png": i73,
	"Suggested.png": i74,
	"Text.png": i75,
	"Translate.png": i77,
	"TVRemote.png": i78,
	"TVRemote_OpenApp.png": i79,
	"TVRemote_PlayPause.png": i80,
	"TVRemote_Power.png": i81,
	"TVRemote_Sleep.png": i82,
	"Twitter.png": i83,
	"URL.png": i84,
	"Variable.png": i85,
	"Video.png": i86,
	"Wallpaper.png": i87,
	"Weather.png": i88,
	"Web.png": i89,
	"WiFi.png": i90,
	"Wi-Fi.png": i90,
	"ZZZZPackedAsset-1.0_Normal.png": i91,
	"ZZZZPackedAsset-2.0.png": i92,
	"ZZZZPackedAsset-3.0_Normal@3x.png": i93,
	"NoIcon.png":
		"https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Red_x.svg/600px-Red_x.svg.png",
};
